import { Box } from '@mui/material';
import { FullPageLoader, PageContentLayout } from '@tassomutuo-backoffice/ui';
import DashboardHeaderSection from './components/DashboardHeaderSection';
import useDashboardPdf from './hooks/useDashboardPdf';
import { useRef } from 'react';
import useAdminStatistics from './hooks/useAdminStatistics';
import DashboardAdminContent from './components/DashboardAdminContent';

const DashboardAdminPage = () => {
  const { isPrinting, generatePdf } = useDashboardPdf({
    from: 'dashboard-admin',
  });
  const contentPrintableRef = useRef<HTMLDivElement>(null);

  const {
    isPending,
    error,
    selectedPeriod,
    setSelectedPeriod,
    selectedComparisonPeriod,
    setSelectedComparisonPeriod,
    benchmarkStatistics,
    dateRange,
    setDateRange,
    regionsFilterOptions,
    selectedRegion,
    setSelectedRegion,
    provincesFilterOptions,
    selectedProvince,
    setSelectedProvince,
    getFilterText,
  } = useAdminStatistics();

  return (
    <Box sx={{ backgroundColor: '#E9EAEB', minHeight: '100vh' }}>
      <FullPageLoader show={isPending || isPrinting} />

      <PageContentLayout error={error} containerSx={{ pt: 0 }}>
        <DashboardHeaderSection
          title="Statistiche admin"
          subtitle="Monitora le performance dei consulenti"
          selectedPeriod={selectedPeriod}
          setSelectedPeriod={setSelectedPeriod}
          selectedComparisonPeriod={selectedComparisonPeriod}
          setSelectedComparisonPeriod={setSelectedComparisonPeriod}
          onExportPdfClick={() =>
            generatePdf('download', contentPrintableRef, getFilterText())
          }
          dateRange={dateRange}
          setDateRange={setDateRange}
          hideMemberSelect
          regionsFilterOptions={regionsFilterOptions}
          selectedRegion={selectedRegion}
          setSelectedRegion={setSelectedRegion}
          provincesFilterOptions={provincesFilterOptions}
          selectedProvince={selectedProvince}
          setSelectedProvince={setSelectedProvince}
        />
        {/* This div is what html2canvas will capture */}
        {benchmarkStatistics && (
          <Box
            ref={contentPrintableRef}
            sx={{ px: 0, pb: 4, width: isPrinting ? 1200 : undefined }}
          >
            <DashboardAdminContent
              benchmarkStatistics={benchmarkStatistics}
              showAllCharts={isPrinting}
              isPrinting={isPrinting}
            />
          </Box>
        )}
      </PageContentLayout>
    </Box>
  );
};

export default DashboardAdminPage;
